var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8163 30.75H8.18299C7.65352 30.7505 7.13918 30.5734 6.72222 30.2471C6.30526 29.9208 6.00977 29.4641 5.88299 28.95L1.46632 11.2667C1.42323 11.0945 1.41997 10.9148 1.4568 10.7412C1.49363 10.5676 1.56958 10.4047 1.67886 10.2649C1.78815 10.125 1.92789 10.012 2.08745 9.93432C2.24702 9.85665 2.4222 9.81641 2.59966 9.81665H33.3997C33.5771 9.81641 33.7523 9.85665 33.9119 9.93432C34.0714 10.012 34.2112 10.125 34.3205 10.2649C34.4297 10.4047 34.5057 10.5676 34.5425 10.7412C34.5793 10.9148 34.5761 11.0945 34.533 11.2667L30.1163 28.95C29.9896 29.4641 29.6941 29.9208 29.2771 30.2471C28.8601 30.5734 28.3458 30.7505 27.8163 30.75V30.75Z",
    stroke: "#151515",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3328 1.25L9.49951 9.81667",
    stroke: "#151515",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1333 1.25L25.9833 9.81667",
    stroke: "#151515",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.e4d9053f.svg";
export { ForwardRef as ReactComponent };